import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="mx-auto mt-32 max-w-xl px-4 text-center">
      <h1 className="text-6xl font-semibold tracking-tight">404</h1>
      <p className="mt-4 text-lg text-neutral-500">
        That page does not exist (yet).
      </p>
      <Link
        to="/"
        className="mt-8 inline-block rounded-lg bg-neutral-900 px-6 py-3 text-white hover:bg-neutral-700 dark:bg-neutral-100 dark:text-neutral-900"
      >
        Back to home
      </Link>
    </div>
  );
}
